export default __webpack_public_path__ + "static/media/banner2-mobile.801b0f45.png";